// User roles and permissions
export var UserRole;
(function (UserRole) {
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
    UserRole["OWNER"] = "OWNER";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["MANAGER"] = "MANAGER";
    UserRole["TECHNICIAN"] = "TECHNICIAN";
    UserRole["OFFICE_STAFF"] = "OFFICE_STAFF";
})(UserRole || (UserRole = {}));
/** Employment / tax classification for field workers */
export var EmploymentType;
(function (EmploymentType) {
    EmploymentType["W2"] = "W2";
    EmploymentType["CONTRACTOR_1099"] = "CONTRACTOR_1099";
})(EmploymentType || (EmploymentType = {}));
/** Per-technician acceptance on job_technicians when job_acceptance is enabled */
export var JobAcceptanceStatus;
(function (JobAcceptanceStatus) {
    JobAcceptanceStatus["PENDING"] = "pending";
    JobAcceptanceStatus["ACCEPTED"] = "accepted";
    JobAcceptanceStatus["DECLINED"] = "declined";
    JobAcceptanceStatus["NOT_REQUIRED"] = "not_required";
})(JobAcceptanceStatus || (JobAcceptanceStatus = {}));
// Job statuses
export var JobStatus;
(function (JobStatus) {
    JobStatus["DRAFT"] = "DRAFT";
    JobStatus["SCHEDULED"] = "SCHEDULED";
    JobStatus["IN_PROGRESS"] = "IN_PROGRESS";
    JobStatus["ON_HOLD"] = "ON_HOLD";
    JobStatus["COMPLETED"] = "COMPLETED";
    JobStatus["CANCELLED"] = "CANCELLED";
})(JobStatus || (JobStatus = {}));
// Estimate statuses
export var EstimateStatus;
(function (EstimateStatus) {
    EstimateStatus["DRAFT"] = "DRAFT";
    EstimateStatus["SENT"] = "SENT";
    EstimateStatus["VIEWED"] = "VIEWED";
    EstimateStatus["ACCEPTED"] = "ACCEPTED";
    EstimateStatus["REJECTED"] = "REJECTED";
    EstimateStatus["EXPIRED"] = "EXPIRED";
    EstimateStatus["CONVERTED"] = "CONVERTED";
})(EstimateStatus || (EstimateStatus = {}));
// Invoice statuses
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["DRAFT"] = "DRAFT";
    InvoiceStatus["SENT"] = "SENT";
    InvoiceStatus["VIEWED"] = "VIEWED";
    InvoiceStatus["OVERDUE"] = "OVERDUE";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    InvoiceStatus["CANCELLED"] = "CANCELLED";
})(InvoiceStatus || (InvoiceStatus = {}));
// Payment methods
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CASH"] = "CASH";
    PaymentMethod["CHECK"] = "CHECK";
    PaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentMethod["ACH"] = "ACH";
    PaymentMethod["WIRE"] = "WIRE";
    PaymentMethod["PAYPAL"] = "PAYPAL";
    PaymentMethod["STRIPE"] = "STRIPE";
    PaymentMethod["OTHER"] = "OTHER";
})(PaymentMethod || (PaymentMethod = {}));
// Payment statuses
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "PENDING";
    PaymentStatus["PROCESSING"] = "PROCESSING";
    PaymentStatus["COMPLETED"] = "COMPLETED";
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["CANCELLED"] = "CANCELLED";
    PaymentStatus["REFUNDED"] = "REFUNDED";
})(PaymentStatus || (PaymentStatus = {}));
// Item types for price book
export var ItemType;
(function (ItemType) {
    ItemType["SERVICE"] = "SERVICE";
    ItemType["PRODUCT"] = "PRODUCT";
    ItemType["LABOR"] = "LABOR";
    ItemType["MATERIAL"] = "MATERIAL";
    ItemType["EQUIPMENT"] = "EQUIPMENT";
    ItemType["DISCOUNT"] = "DISCOUNT";
    ItemType["MISC"] = "MISC";
})(ItemType || (ItemType = {}));
// Purchase Order Status
export var PurchaseOrderStatus;
(function (PurchaseOrderStatus) {
    PurchaseOrderStatus["DRAFT"] = "DRAFT";
    PurchaseOrderStatus["SENT"] = "SENT";
    PurchaseOrderStatus["PARTIALLY_RECEIVED"] = "PARTIALLY_RECEIVED";
    PurchaseOrderStatus["RECEIVED"] = "RECEIVED";
    PurchaseOrderStatus["CANCELLED"] = "CANCELLED";
})(PurchaseOrderStatus || (PurchaseOrderStatus = {}));
// Receipt Condition
export var ReceiptCondition;
(function (ReceiptCondition) {
    ReceiptCondition["GOOD"] = "GOOD";
    ReceiptCondition["DAMAGED"] = "DAMAGED";
    ReceiptCondition["DEFECTIVE"] = "DEFECTIVE";
})(ReceiptCondition || (ReceiptCondition = {}));
// Subscription plans
export var SubscriptionPlan;
(function (SubscriptionPlan) {
    SubscriptionPlan["STARTER"] = "STARTER";
    SubscriptionPlan["PROFESSIONAL"] = "PROFESSIONAL";
    SubscriptionPlan["ENTERPRISE"] = "ENTERPRISE";
})(SubscriptionPlan || (SubscriptionPlan = {}));
// File/attachment types
export var FileType;
(function (FileType) {
    FileType["IMAGE"] = "IMAGE";
    FileType["PDF"] = "PDF";
    FileType["DOC"] = "DOC";
    FileType["EXCEL"] = "EXCEL";
    FileType["VIDEO"] = "VIDEO";
    FileType["AUDIO"] = "AUDIO";
    FileType["OTHER"] = "OTHER";
})(FileType || (FileType = {}));
// Audit log actions
export var AuditLogAction;
(function (AuditLogAction) {
    AuditLogAction["CREATE"] = "CREATE";
    AuditLogAction["UPDATE"] = "UPDATE";
    AuditLogAction["DELETE"] = "DELETE";
    AuditLogAction["LOGIN"] = "LOGIN";
    AuditLogAction["LOGOUT"] = "LOGOUT";
    AuditLogAction["VIEW"] = "VIEW";
    AuditLogAction["EXPORT"] = "EXPORT";
    AuditLogAction["SEND"] = "SEND";
    AuditLogAction["PRINT"] = "PRINT";
})(AuditLogAction || (AuditLogAction = {}));
// Notification types
export var NotificationType;
(function (NotificationType) {
    NotificationType["INFO"] = "INFO";
    NotificationType["SUCCESS"] = "SUCCESS";
    NotificationType["WARNING"] = "WARNING";
    NotificationType["ERROR"] = "ERROR";
    NotificationType["JOB_REMINDER"] = "JOB_REMINDER";
    NotificationType["PAYMENT_REMINDER"] = "PAYMENT_REMINDER";
    NotificationType["ESTIMATE_VIEWED"] = "ESTIMATE_VIEWED";
    NotificationType["INVOICE_PAID"] = "INVOICE_PAID";
})(NotificationType || (NotificationType = {}));
// Priority levels
export var Priority;
(function (Priority) {
    Priority["LOW"] = "LOW";
    Priority["MEDIUM"] = "MEDIUM";
    Priority["HIGH"] = "HIGH";
    Priority["URGENT"] = "URGENT";
})(Priority || (Priority = {}));
// Business days
export var BusinessDay;
(function (BusinessDay) {
    BusinessDay["MONDAY"] = "MONDAY";
    BusinessDay["TUESDAY"] = "TUESDAY";
    BusinessDay["WEDNESDAY"] = "WEDNESDAY";
    BusinessDay["THURSDAY"] = "THURSDAY";
    BusinessDay["FRIDAY"] = "FRIDAY";
    BusinessDay["SATURDAY"] = "SATURDAY";
    BusinessDay["SUNDAY"] = "SUNDAY";
})(BusinessDay || (BusinessDay = {}));
// Time entry types
export var TimeEntryType;
(function (TimeEntryType) {
    TimeEntryType["REGULAR"] = "REGULAR";
    TimeEntryType["OVERTIME"] = "OVERTIME";
    TimeEntryType["TRAVEL"] = "TRAVEL";
    TimeEntryType["BREAK"] = "BREAK";
})(TimeEntryType || (TimeEntryType = {}));
// Vehicle statuses
export var VehicleStatus;
(function (VehicleStatus) {
    VehicleStatus["ACTIVE"] = "ACTIVE";
    VehicleStatus["INACTIVE"] = "INACTIVE";
    VehicleStatus["MAINTENANCE"] = "MAINTENANCE";
    VehicleStatus["OUT_OF_SERVICE"] = "OUT_OF_SERVICE";
})(VehicleStatus || (VehicleStatus = {}));
// Address types
export var AddressType;
(function (AddressType) {
    AddressType["BILLING"] = "BILLING";
    AddressType["SHIPPING"] = "SHIPPING";
    AddressType["SERVICE"] = "SERVICE";
    AddressType["HOME"] = "HOME";
    AddressType["WORK"] = "WORK";
    AddressType["OTHER"] = "OTHER";
})(AddressType || (AddressType = {}));
// Contact types  
export var ContactType;
(function (ContactType) {
    ContactType["PRIMARY"] = "PRIMARY";
    ContactType["SECONDARY"] = "SECONDARY";
    ContactType["EMERGENCY"] = "EMERGENCY";
    ContactType["BILLING"] = "BILLING";
})(ContactType || (ContactType = {}));
// Customer types
export var CustomerType;
(function (CustomerType) {
    CustomerType["RESIDENTIAL"] = "residential";
    CustomerType["COMMERCIAL"] = "commercial";
    CustomerType["OTHER"] = "other";
})(CustomerType || (CustomerType = {}));
// Customer contact roles
export var CustomerContactRole;
(function (CustomerContactRole) {
    CustomerContactRole["BILLING_OWNER"] = "BILLING_OWNER";
    CustomerContactRole["SERVICE_TENANT"] = "SERVICE_TENANT";
    CustomerContactRole["PRIMARY"] = "PRIMARY";
    CustomerContactRole["PROPERTY_MANAGER"] = "PROPERTY_MANAGER";
    CustomerContactRole["ACCOUNT_MANAGER"] = "ACCOUNT_MANAGER";
    CustomerContactRole["SITE_CONTACT"] = "SITE_CONTACT";
    CustomerContactRole["FACILITY_MANAGER"] = "FACILITY_MANAGER";
    CustomerContactRole["OTHER"] = "OTHER";
})(CustomerContactRole || (CustomerContactRole = {}));
// Communication preferences
export var CommunicationPreference;
(function (CommunicationPreference) {
    CommunicationPreference["EMAIL"] = "EMAIL";
    CommunicationPreference["SMS"] = "SMS";
    CommunicationPreference["PHONE"] = "PHONE";
    CommunicationPreference["MAIL"] = "MAIL";
    CommunicationPreference["NONE"] = "NONE";
})(CommunicationPreference || (CommunicationPreference = {}));
// SMS opt-in methods
export var SmsOptInMethod;
(function (SmsOptInMethod) {
    SmsOptInMethod["DIGITAL_WEB_FORM"] = "digital_web_form";
    SmsOptInMethod["DIGITAL_MOBILE_APP"] = "digital_mobile_app";
    SmsOptInMethod["DIGITAL_CUSTOMER_PORTAL"] = "digital_customer_portal";
    SmsOptInMethod["DIGITAL_WIDGET"] = "digital_widget";
    SmsOptInMethod["KEYWORD_INBOUND"] = "keyword_inbound";
    SmsOptInMethod["VERBAL_PHONE"] = "verbal_phone";
    SmsOptInMethod["VERBAL_IN_PERSON"] = "verbal_in_person";
    SmsOptInMethod["PAPER_FORM"] = "paper_form";
    SmsOptInMethod["PAPER_CONTRACT"] = "paper_contract";
})(SmsOptInMethod || (SmsOptInMethod = {}));
// SMS opt-out reasons
export var SmsOptOutReason;
(function (SmsOptOutReason) {
    SmsOptOutReason["CUSTOMER_REQUEST"] = "customer_request";
    SmsOptOutReason["BOUNCE"] = "bounce";
    SmsOptOutReason["INVALID_NUMBER"] = "invalid_number";
    SmsOptOutReason["SPAM_COMPLAINT"] = "spam_complaint";
    SmsOptOutReason["CARRIER_BLOCK"] = "carrier_block";
})(SmsOptOutReason || (SmsOptOutReason = {}));
//# sourceMappingURL=enums.js.map